import axios from "axios";
import { IVolunteerHistory } from "../types";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";

export const QUERY_KEY_FOR_SINGLE_VOLUNTEER = "get-volunteer-experience";

export const getSingleVolunteer = async (
  props: IGeneralProps
): Promise<IVolunteerHistory> => {
  const id = props.id;
  const url = `${END_POINT.BASE_URL}/v1/get-volunteer-experience/${id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);


  const item = res.data;

  const data: IVolunteerHistory = {
    id: item.id,
    talent_id: item.talent_id,
    title: item.title,    
    company: item.company,
    type: item.type,
    start_date: item.start_date,
    end_date: item.end_date,
    is_current: item.is_current,
    description: item.description,
    months: item.months,
  };
  return data;
};

export const useGetSingleVolunteer = ({ id, token }: IGeneralProps) => {
  const queryData = useQuery([QUERY_KEY_FOR_SINGLE_VOLUNTEER, id], () =>
    getSingleVolunteer({
      id,
      token,
    })
  );

  return queryData;
};
